import { render } from "./Game.vue?vue&type=template&id=0c8d8f9b"
import script from "./Game.vue?vue&type=script&lang=js"
export * from "./Game.vue?vue&type=script&lang=js"

import exportComponent from "/home/welchome/public_html/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__